import { render } from "./Campaign20230410_1.vue?vue&type=template&id=52dd2403&scoped=true"
import script from "./Campaign20230410_1.vue?vue&type=script&lang=js"
export * from "./Campaign20230410_1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dd2403"]])

export default __exports__